export default __webpack_public_path__ + "static/media/practice.e2367859.gif";